module.exports = __webpack_public_path__ + "static/media/DarwinHeaderDark.dcbcb87e.svg";